import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AwsEstimate',
    props: {
        jobRuntimeInSeconds: null,
        coresAllocated: null,
        memoryAllocatedInMebibyte: null,
        ec2Instances: null
    },
    setup(__props) {
        const props = __props;
        const computedAwsEstimate = computed(() => {
            const { coresAllocated, jobRuntimeInSeconds, memoryAllocatedInMebibyte } = props;
            if (coresAllocated <= 0 || jobRuntimeInSeconds <= 0) {
                return;
            }
            const adjustedMemoryAllocated = memoryAllocatedInMebibyte ? memoryAllocatedInMebibyte / 1024 : 0.5;
            // Estimate EC2 instance. Data is already sorted
            const ec2Instance = props.ec2Instances.find((ec) => {
                return ec.mem >= adjustedMemoryAllocated && ec.vCpuCount >= coresAllocated;
            });
            if (!ec2Instance) {
                return;
            }
            return {
                seconds: jobRuntimeInSeconds,
                requestedVCpuCount: coresAllocated,
                memory: adjustedMemoryAllocated,
                price: ((jobRuntimeInSeconds * ec2Instance.price) / 3600).toFixed(2),
                instance: ec2Instance,
            };
        });
        return { __sfc: true, props, computedAwsEstimate };
    }
});
